// Presentation only: never use these labels to calculate or submit booking times.
function formatClockText(value, clock = 'standard') {
  if (!['ethiopian', 'both'].includes(clock)) return value;
  return String(value).replace(/\b(1[0-2]|0?[1-9])(?::([0-5]\d))?\s*(am|pm)\b/gi, (standard, hour, minutes, period) => {
    const h = Number(hour) % 12 + (period.toLowerCase() === 'pm' ? 12 : 0);
    const ethiopianHour = ((h + 6) % 12) || 12;
    const label = `${ethiopianHour}:${minutes || '00'} ${h >= 6 && h < 18 ? 'daytime' : 'nighttime'}`;
    return clock === 'both' ? `${label} (${standard.trim()})` : label;
  });
}
function clockForCalendar(calendar) { return calendar === 'ethiopic' ? 'ethiopian' : 'standard'; }
function ethiopianClockParts(value) {
  const match = /^(\d{2}):([0-5]\d)$/.exec(String(value));
  if (!match || Number(match[1]) > 23) return null;
  const h = Number(match[1]);
  return { hour: ((h + 6) % 12) || 12, minute: Number(match[2]), period: h >= 6 && h < 18 ? 'daytime' : 'nighttime' };
}
function fromEthiopianClock(hour, minute, period) {
  if (!Number.isInteger(Number(hour)) || Number(hour) < 1 || Number(hour) > 12 || !Number.isInteger(Number(minute)) || Number(minute) < 0 || Number(minute) > 59 || !['daytime', 'nighttime'].includes(period)) throw new RangeError('Invalid Ethiopian time');
  const h = ((Number(hour) % 12) + (period === 'daytime' ? 6 : 18)) % 24;
  return `${String(h).padStart(2, '0')}:${String(minute).padStart(2, '0')}`;
}
// Booking clock labels follow the selected timezone independently of date calendar.
function clockForTimezone(clock, timezone) {
  return timezone === 'Africa/Addis_Ababa' && ['ethiopian', 'both'].includes(clock) ? clock : 'standard';
}
module.exports = { clockForTimezone, formatClockText, clockForCalendar, ethiopianClockParts, fromEthiopianClock };
